import { useBreakpoint } from '../components/media-query/use-breakpoint';
export var useIsMobile = () => {
  var breakpoint = useBreakpoint() || 'lg';
  return ['base', 'xs', 'sm', 'md', 'mdlg'].includes(breakpoint);
};